import Vue from "vue";
import Vuex, { Store } from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    debugMode: Boolean,
    contactForm: Array
  },
  mutations: {
    set_debugMode(state, status) {
      state.debugMode = status;
    },
    set_contactForm(state, contactf) {
      state.contactForm = contactf;
    }
  },
  actions: {
    setDebugMode(state, status) {
      this.commit("set_debugMode", status);
    },
    setContactForm(state, contactf) {
      this.commit("set_contactForm", contactf);
    }
  }
});
